import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  buttonRow: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: theme.spacing(2),
  },
  button: {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.header.main,
  },
}));

const RecentlyUsed = () => {
  const classes = useStyles();

  const buttonList = ['New Cardholder', 'Bulk Cardholder Update', 'Email a Report', 'Run a Report'];

  return (
    <>
      <Typography variant="h6">Recently Used</Typography>
      <div className={classes.buttonRow}>
        {buttonList.map((button) => (
          <Button className={classes.button} variant="contained" key={button}>
            {button}
          </Button>
        ))}
      </div>
    </>
  );
};

export default RecentlyUsed;
